import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const EmulationActionContainer = styled(Box).attrs({
  flexGrow: { sm: 1 },
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings[400]};
    cursor: pointer;
    color: ${theme.colors.grey[900]};
  `};
`;

export const UserEmulateIconContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    color: ${theme.colors.green[500]};
    padding-bottom: ${theme.spacings[400]};
  `};
`;
